/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectPhysicsTheme} from "./searchObjects"



export function fillSearchObjectPhysicsTheme(){
    searchObjectPhysicsTheme.categories = [];
    searchObjectPhysicsTheme.keywords = [];

    const checkbox = document.getElementById("categoryPhysicsTheme");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectPhysicsTheme.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonPhysicsThemeAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectPhysicsTheme.any = true;
    }

    const allButton = document.getElementById("buttonPhysicsThemeAll");
    if(allButton.classList.contains("chosen")){
        searchObjectPhysicsTheme.any = false;
    }
    
    const buttonBPhysicsandsimilar = document.getElementById("buttonPhysicsThemeBPhysicsandsimilar");
    if(buttonBPhysicsandsimilar.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonBPhysicsandsimilar.value)
    }
    
    const buttonHeavyIonPhysics = document.getElementById("buttonPhysicsThemeHeavyIonPhysics");
    if(buttonHeavyIonPhysics.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonHeavyIonPhysics.value)
    }
    
    const buttonPhysicsobjectsandDetectorperformance = document.getElementById("buttonPhysicsThemePhysicsobjectsandDetectorperformance");
    if(buttonPhysicsobjectsandDetectorperformance.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonPhysicsobjectsandDetectorperformance.value)
    }
    
    const buttonSearchesforphysicsbeyondtheStandardModel = document.getElementById("buttonPhysicsThemeSearchesforphysicsbeyondtheStandardModel");
    if(buttonSearchesforphysicsbeyondtheStandardModel.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonSearchesforphysicsbeyondtheStandardModel.value)
    }
    
    const buttonStandardModel = document.getElementById("buttonPhysicsThemeStandardModel");
    if(buttonStandardModel.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonStandardModel.value)
    }
    
    const buttonUpgradestudies = document.getElementById("buttonPhysicsThemeUpgradestudies");
    if(buttonUpgradestudies.classList.contains('selected')){
        searchObjectPhysicsTheme.keywords.push(buttonUpgradestudies.value)
    }
    
    getAllFiltered()

}